import { z } from 'zod';
import { emptyStringToUndefined } from '@utils/zod';
import { AccountType } from '@prisma/client';

export const updateReferralCodesBody = z.object({
  inviteCodes: z
    .array(
      z.object({
        value: z.string(),
      })
    )
    .transform(arr =>
      arr.filter(v => v.value.trim()).map(v => ({ value: v.value.replaceAll(' ', '-') }))
    )
    .optional(),
});

export const updateProfileBody = z
  .object({
    nickname: z.string().min(3).max(30).optional().or(emptyStringToUndefined),
    about: z.string().max(2000).optional().or(emptyStringToUndefined),
    twitter: z.string().optional().or(emptyStringToUndefined),
    discord: z.string().optional().or(emptyStringToUndefined),
    discordServerInvite: z.string().optional().or(emptyStringToUndefined),
    instagram: z.string().optional().or(emptyStringToUndefined),
    tiktok: z.string().optional().or(emptyStringToUndefined),
    email: z.string().email().optional().or(emptyStringToUndefined),
    payoutAddress: z.string().optional().or(emptyStringToUndefined),
    onboarded: z.boolean().optional().or(emptyStringToUndefined),
    activatePartnerMarketplace: z.boolean().optional(),
    type: z.enum([AccountType.CREATOR, AccountType.AFFILIATE, AccountType.REFEREE]).optional(),
    categories: z
      .array(
        z.object({
          value: z.string(),
        })
      )
      .optional(),
  })
  .merge(updateReferralCodesBody);

export type UpdateReferralsCodesBody = z.infer<typeof updateReferralCodesBody>;
export type UpdateProfileBody = z.infer<typeof updateProfileBody>;
